export type IdsPublicConnection = {
  id: string;
  supplierId?: string | null;
  supplierSlug?: string | null;
};

export function pickIdsConnectionForSupplier(
  connections: IdsPublicConnection[],
  opts?: { connectionId?: string | null; supplierId?: string | null; supplierSlug?: string | null },
): IdsPublicConnection | null {
  if (!connections.length) return null;
  const connectionId = String(opts?.connectionId ?? "").trim();
  if (connectionId) {
    const byId = connections.find((row) => row.id === connectionId);
    if (byId) return byId;
  }
  const supplierSlug = String(opts?.supplierSlug ?? "").trim().toLowerCase();
  if (supplierSlug) {
    const bySlug = connections.find((row) => String(row.supplierSlug ?? "").toLowerCase() === supplierSlug);
    if (bySlug) return bySlug;
  }
  const supplierId = String(opts?.supplierId ?? "").trim();
  if (supplierId) {
    const bySupplier = connections.find((row) => row.supplierId === supplierId);
    if (bySupplier) return bySupplier;
  }
  return connections.length === 1 ? connections[0] : null;
}

export function openIdsShopHtml(html: string, existing?: Window | null): boolean {
  const w = existing && !existing.closed ? existing : window.open('about:blank', '_blank');
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}

export async function launchIdsArticleDeeplink(opts: {
  articleNumber: string;
  connectionId?: string;
  supplierId?: string;
  supplierSlug?: string;
  leadRouteId?: string;
  offeringId?: string;
}): Promise<void> {
  const articleNumber = opts.articleNumber.trim();
  if (!articleNumber) throw new Error('Artikelnummer fehlt.');

  let connectionId = opts.connectionId || '';
  if (!connectionId) {
    const res = await fetch('/api/integrations/ids/connections', { credentials: 'include' });
    const d = await res.json();
    const connections = Array.isArray(d?.connections) ? d.connections : [];
    connectionId = pickIdsConnectionForSupplier(connections, {
      supplierId: opts.supplierId,
      supplierSlug: opts.supplierSlug,
    })?.id ?? '';
  }
  if (!connectionId) throw new Error('Keine IDS-Verbindung.');

  const popup = window.open('about:blank', '_blank');
  const url =
    opts.leadRouteId && opts.offeringId
      ? `/api/leads/${encodeURIComponent(opts.leadRouteId)}/offerings/${encodeURIComponent(opts.offeringId)}/ids/adl`
      : '/api/integrations/ids/adl';
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      connectionId,
      articleNumber,
      ...(opts.supplierId ? { supplierId: opts.supplierId } : {}),
      ...(opts.supplierSlug ? { supplierSlug: opts.supplierSlug } : {}),
    }),
  });
  const d = await res.json();
  if (!res.ok) {
    popup?.close();
    throw new Error(d?.error || 'Deeplink fehlgeschlagen.');
  }
  if (!openIdsShopHtml(String(d.html || ''), popup)) {
    popup?.close();
    throw new Error('Popup wurde blockiert.');
  }
}
